import FORBIDDEN_CHARACTER from '~/assets/data/characters/FORBIDDEN_CHARACTER.json';
import NEW_LINE_CHARACTERS from '~/assets/data/characters/NEW_LINE_CHARACTERS.json';
import NONSTANDARD_CHARACTER from '~/assets/data/characters/NONSTANDARD_CHARACTER.json';
import OLD_CHARACTER from '~/assets/data/characters/OLD_CHARACTERS.json';
import PERMITTED_CHARACTER from '~/assets/data/characters/PERMITTED_CHARACTER.json';
import PLATFORM_DEPENDENT_CHARACTER from '~/assets/data/characters/PLATFORM_DEPENDENT_CHARACTER.json';
import SPECIFIED_PERMITTED_CHARACTER from '~/assets/data/characters/SPECIFIED_PERMITTED_CHARACTER.json';

// 文字のオブジェクトからkeyだけを取り出して、使用可能な文字の配列に変換する
const charKeyToArray = (codeSet: typeof SPECIFIED_PERMITTED_CHARACTER) => {
  return Object.keys(codeSet).map((codeUnit) => {
    const decimalNewCodeUnit = parseInt(codeUnit, 16);
    return String.fromCodePoint(decimalNewCodeUnit);
  });
};
/**
 * 使用可能な文字列に変換する
 * @param {*} string 文字列
 * @returns 使用可能な文字列
 */
export const convertAvailableString = (string: String, isCheckOnlyPermitCharacter?: Boolean) => {
  const chars = Array.from(string);
  const newString = chars.reduce((acc: String, char: String) => {
    // 特殊許可文字を許可する場合、リストに含まれている文字はそのまま返す
    if (isCheckOnlyPermitCharacter && charKeyToArray(SPECIFIED_PERMITTED_CHARACTER).includes(char.toString())) {
      return `${acc}${char}`;
    }
    let currentChar = char;
    // 禁止文字を変換する
    currentChar = convertUsableChar(FORBIDDEN_CHARACTER, currentChar);
    // 旧字を新字に変換する
    currentChar = convertUsableChar(OLD_CHARACTER, currentChar);
    // 俗字を正字に変換する
    currentChar = convertUsableChar(NONSTANDARD_CHARACTER, currentChar);
    // 固有文字を変換する
    currentChar = convertUsableChars(PLATFORM_DEPENDENT_CHARACTER, currentChar);
    // 許可文字に変換する
    currentChar = convertPermitCharacter(currentChar);
    return `${acc}${currentChar}`;
  }, '');
  return newString;
};
/**
 * 許可文字に変換する
 * @param {*} string 変換対象の文字列
 * @returns 変換後の文字
 */
const convertPermitCharacter = (convertedChar: String) => {
  // 改行文字はそのまま返す
  if (NEW_LINE_CHARACTERS.list.includes(convertedChar.toString())) {
    return convertedChar;
  }
  // 変換後の文字が複数になる可能性があるため再分割する
  const chars = Array.from(convertedChar);
  return chars.reduce((acc, char) => {
    const hexCodeUnit = char.charCodeAt(0).toString(16);
    // 許可文字でなければ半角スペースに変換する
    if ((PERMITTED_CHARACTER as any)[hexCodeUnit] === undefined) {
      return acc + ' ';
    }
    return acc + char;
  }, '');
};
/**
 * 使用可能な文字に変換する
 * @param {*} char 変換対象の文字
 * @returns 変換後の文字
 */
const convertUsableChar = (charData: Object, char: String) => {
  // 16進数のUTF-16コードユニットを取得する
  const hexCodeUnit = char.charCodeAt(0).toString(16);
  if ((charData as any)[hexCodeUnit]) {
    // 10進数整数に変換
    const decimalNewCodeUnit = parseInt((charData as any)[hexCodeUnit], 16);
    // 使用可能な文字列に変換
    return String.fromCodePoint(decimalNewCodeUnit);
  }
  return char;
};
/**
 * 使用可能な文字列に変換する
 * @param {*} char 変換対象の文字
 * @returns 変換後の文字列
 */
const convertUsableChars = (charData: Object, char: String) => {
  // 16進数のUTF-16コードユニットを取得する
  const hexCodeUnit = char.charCodeAt(0).toString(16);
  if ((charData as any)[hexCodeUnit]) {
    return (charData as any)[hexCodeUnit].reduce((acc: String, codeUnit: string) => {
      // 10進数整数に変換
      const decimalNewCodeUnit = parseInt(codeUnit, 16);
      // 使用可能な文字列に変換
      return acc + String.fromCodePoint(decimalNewCodeUnit);
    }, '');
  }
  return char;
};
